import React, { useContext, useEffect, useState } from 'react'
import { OpenClient } from '../common/OpenInAgent'
import withWebsocket from '~/decorators/withWebsocket'
import { WithWebsocketProps } from '~/decorators/withWebsocket'
import { formatPhoneNumber } from '~/utils/string'
import { Link } from 'react-router-dom'
import { LanguageIcon } from './LanguageIcon'
import { ClientOnShow } from '../clients/Show'
import { CallOnShow } from '../calls/types'
import { UsersManagerContext } from '~/service/UsersManager'
import { User } from '~/service/UsersManager'
import Tooltip from './Tooltip'
import { FormattedMessage } from '~/translations/utils'

type ApiDataPresence = {
  presence: number[]
}

type ApiDataType = ApiDataPresence & {}

type Props = {
  client: ClientOnShow
  call?: CallOnShow
  showAvatar?: boolean
  showPresence?: boolean
  nameAsLink?: boolean
}

const ClientHeaderComp: React.FC<Props & WithWebsocketProps<ApiDataType>> = ({
  client,
  call,
  showAvatar = true,
  showPresence = true,
  nameAsLink = true,
  apiData,
  channel,
}) => {
  const { get: getUser } = useContext(UsersManagerContext)

  const presenceToUsers = (ids: number[]) =>
    ids
      .filter(userId => userId != window.c.userId)
      .map(userId => getUser(userId))
      .filter(user => user) as User[]

  const [presence, setPresence] = useState<User[]>(
    presenceToUsers(apiData.presence)
  )

  useEffect(() => {
    channel.on('presence', (data: ApiDataPresence) => {
      setPresence(presenceToUsers(data.presence))
    })
  }, [])

  return (
    <div className="clientHeader">
      {showAvatar && <img src={client.avatar} />}

      {showPresence && presence.length > 0 && (
        <div className="clientHeader-presence">
          <div className="clientHeader-presence-label">
            <FormattedMessage id="client / presence" />:
          </div>

          <div className="clientHeader-presence-images">
            {presence.map(user => {
              return (
                <Tooltip key={user.id} content={user.name}>
                  <img src={user.avatar} />
                </Tooltip>
              )
            })}
          </div>
        </div>
      )}

      <h1>
        {nameAsLink ? (
          <Link to={'/clients/' + client.id}>{client.name}</Link>
        ) : (
          <strong>{client.name}</strong>
        )}

        {call && <LanguageIcon call={call} />}
      </h1>

      {call && formatPhoneNumber(call.number)}

      <OpenClient client={client} />
    </div>
  )
}
const ClientHeader = withWebsocket<
  ApiDataType,
  WithWebsocketProps<ApiDataType>,
  Props
>(
  ClientHeaderComp,
  (params, props) => `phone_client:${window.c.campaignId}:${props.client.id}`
)

export default ClientHeader
